export default "__VITE_ASSET__lYhmzmZo__"